export const EnvUtils = {
    production: false,
    eclair: false,
    webview: false,
    standalone: false,
    basicat: 'ECQ',
    version: undefined,
    isEclair: (): boolean => {
        return EnvUtils.eclair;
    },
    isWebview: (): boolean => {
        return EnvUtils.webview;
    },
    isStandalone: (): boolean => {
        return EnvUtils.standalone;
    },
    getBasicatCode: (): string => {
        return EnvUtils.basicat;
    },
    getVersion: (): undefined => {
        return EnvUtils.version;
    },
    isProduction: (): boolean => {
        return EnvUtils.production;
    },
};
